import React from 'react';
import styled from 'styled-components';
import IosAirportWifi from '../../../assets/departureWifi/ios_wifi.png';
import IosPortWifi from '../../../assets/departureWifi/ios_wifi_port.png';

type Props = {
  size?: 'sm' | 'md';
  place?: 'airport' | 'port';
};

function IosWifiConnection({ place = 'airport' }: Props) {
  return (
    <Image>
      <img
        src={place === 'airport' ? IosAirportWifi : IosPortWifi}
        alt='와이파이 연결 예시'
      />
    </Image>
  );
}

const Image = styled.div`
  margin: 0 20px;

  & > img {
    width: 100%;
  }
`;

export default IosWifiConnection;
